import {
  Component, OnInit, ChangeDetectionStrategy, Input, ElementRef, ViewChild, Output,
  EventEmitter, OnChanges, SimpleChange, ChangeDetectorRef
} from '@angular/core';
import { Segment } from '../../interfaces/index';
import { SegmentSelectionsHandle, SegmentSelectionsInput } from '@ispm-client/modules/segments/interfaces/segments';
import { handleSegmentSelections } from '@ispm-client/modules/segments/components/segment/segmentSelection';
import { ImageConfiguration } from '@ispm-client/modules/segments/interfaces';


@Component({
  selector: 'ispm-image-segment',
  templateUrl: './image-segment.component.html',
  styleUrls: ['./image-segment.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ImageSegmentComponent implements OnInit, OnChanges {

  constructor(private changeDetectorRef: ChangeDetectorRef) { }

  @Input() segments: Segment[];
  @Input() svgContent: string;
  @Input() readonly: boolean;
  @Input() imageConfig: ImageConfiguration;
  @Input() isEditable: boolean;
  @Input() maximizable: boolean = false;
  segment: Segment;
  load: boolean = false;
  segmentSelectionsInput: SegmentSelectionsInput;
  svg: SVGElement;
  showDialog: boolean = false;
  
  parseSVG = (svg: string, key: string) => {
    if (svg) {
      const parser = new DOMParser();
      const doc = parser.parseFromString(this.svgContent, "image/svg+xml");
      return doc.getElementsByTagName(key)[0]?.childNodes[0]?.nodeValue;
    }
  }

  private selectionsHandler: SegmentSelectionsHandle = handleSegmentSelections();

  @Output() segmentsOut: EventEmitter<Segment> = new EventEmitter();

  @ViewChild('svgContainer', {static: false}) private svgContainer: ElementRef;

  private initSvg = debounce(this, () => {
      const svgContainer = this.svgContainer.nativeElement;
      const svg = svgContainer.querySelector('svg');
      if (!svg) { return; }
      this.svg = svg;
      svgContainer.style.display = 'flex';
      this.load = true;
      this.updateSegmentSelections();
    }
  );

  ngOnInit() {
    this.segment = { name: '', level: { code: ''}, annotator: { }};
  }

  public ngOnChanges(changes: { [propName: string]: SimpleChange}): void {
       if (changes['segments'] || changes['svgContent'] || changes['imageConfig']) {
         this.changeDetectorRef.detectChanges();
         this.initSvg();

       }
  }


  updateSegmentSelections() {
    this.segmentSelectionsInput = {
      readOnly : this.readonly,
      isEditable : this.isEditable,
      svg : this.svg,
      segments : this.segments,
      imageConfig : this.imageConfig,
      emitterSegment : this.segment,
      changed  : () =>  this.readonly ?  '' :  this.segmentsOut.emit(this.segment)
    };
    this.selectionsHandler.reset(this.segmentSelectionsInput);
  }

  openDialog() {
    this.showDialog = !this.showDialog  && this.maximizable;  
  }


}

const debouncedHandles = new Map<any, any>();
const DEBOUNCE_TIME = 100;
function debounce(caller: any, func: any, ...args): any {
  if (debouncedHandles.has(func)) { clearTimeout(debouncedHandles.get(func)); }
  debouncedHandles.set(func, setTimeout(() => { debouncedHandles.delete(func); func.call(caller, ...args); }, DEBOUNCE_TIME));
  return () => debounce(caller, func, ...args);
}
